import axios from "axios";

class QuizShowRepository {

  createUser(params = {}, callback) {
    axios.post("/v1/api/quizshow/users", params)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  updateUser(params = {}, callback) {
    axios.put(`/v1/api/quizshow/users/me:update?accountId=${params.accountId}`, params)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  findMe(params = {}, callback, errCallback) {
    axios.get(`/v1/api/quizshow/users/me?accountId=${params.accountId}`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
        if (res.status !== 200)
          errCallback && errCallback();
      });
  }

  /** GAME */

  searchGame(params = {}, callback) {
    axios.get("/v1/api/quizshow/games", params)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  joinGame(params = {}, callback) {
    axios.put(`/v1/api/quizshow/games/${params.gameId}:join?accountId=${params.accountId}`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  /** QUIZ */

  solveQuiz(params = {}, callback) {
    axios.put(`/v1/api/quizshow/quizzes/${params.quizId}:solve?accountId=${params.accountId}`, params)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

}

export { QuizShowRepository };

